export const GREEN_TICK = 'https://assets.payufin.com/images/green-tick-shadow.png'

const IMAGE_MAPPING = {
  error: 'https://assets.payufin.com/images/error.png',
  payufin_logo: 'https://assets.payufin.com/images/payu-finance-brand.png'
}

export const getImageUrl = icon => IMAGE_MAPPING[icon] || ''
